import * as React from 'react';
import { Notification as INotification } from '../models/interfaces';

interface NotificationProps {
  id: number;
  key: number;
  notification: INotification;
  dismissNotification: (id: number) => void;
}

class Notification extends React.Component<NotificationProps> {
  constructor(props: NotificationProps) {
    super(props);
  }

  render() {
    const notification = this.props.notification;

    return (
      <div className={`notification notification--${notification.type}`}>
        <div className="notification__message">
          {notification.message}
        </div>
        <div
          className={`notification__action button ${notification.type === 'error' ? 'button--notice' : null}`}
          onClick={() => this.props.dismissNotification(this.props.id)}
        >X
        </div>
      </div>
    );
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Notification.tsx